export enum SupportedHistoryEntityType {
  EVENT = 'EVENT',
  ORGANIZER = 'ORGANIZER',
  VENUE = 'VENUE',
}

export enum ActionType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}
